// O excedente acima de 100% precisa ser IDENTIFICÁVEL.
// Toda barra de indicador limita a largura em 100% (`Math.min(100, valor)`), o que é correto: uma
// barra de 125% quebraria o layout. Mas com o teto semântico da Disponibilidade removido, 125% e
// 100% passaram a desenhar EXATAMENTE igual — a barra deixou de distinguir "cumpriu o expediente"
// de "fez hora extra". Clampar sem marcar atende ao layout e falha ao requisito.
// A marcação é rótulo, não cor: "+25 pp" ao lado do número. Precedente: o badge de
// atraso na timeline, pelo mesmo motivo — status nunca só por cor.

export const OVERRUN_THRESHOLD = 100;

export function isOverrun(value: number | null | undefined): boolean {
  return value != null && Number.isFinite(value) && value > OVERRUN_THRESHOLD;
}

interface Props {
  value: number | null | undefined;
  /** O que excedeu, para o rótulo acessível (ex.: "Disponibilidade"). */
  metricLabel: string;
}

export function OverrunBadge({ value, metricLabel }: Props) {
  if (!isOverrun(value)) return null;
  const excess = value! - OVERRUN_THRESHOLD;
  // A Disponibilidade vem arredondada em 2 casas do SQL, então excedentes abaixo de 1 pp são
  // resultados comuns agora que o teto de 100% saiu (uma run que começa alguns segundos antes do
  // turno). Com `toFixed(0)` fixo eles rendiam o rótulo `+0 pp`: um selo de aviso anunciando
  // excedente zero, ao lado de um valor que o desmente. Uma casa decimal abaixo de 1 pp mantém o
  // selo honesto sem tornar o caso comum (dezenas de pp) mais verboso.
  const excessLabel = excess >= 1 ? excess.toFixed(0) : excess.toFixed(1);
  return (
    <span
      // `role="img"`: ARIA proíbe nomear elemento mapeado como `generic`, e um `<span>` cru é
      // exatamente isso — sem role o `aria-label` não vira nome acessível e o leitor cai no texto
      // visível ("mais 25 p p"), que é justamente a abreviação que o rótulo existe p/ expandir.
      role="img"
      className="shrink-0 rounded-sm bg-rd-warning-100 px-1 font-sans text-[9px] font-semibold leading-[14px] text-rd-warning-700"
      aria-label={`${metricLabel} ${excessLabel} pontos percentuais acima de 100%`}
    >
      +{excessLabel} pp
    </span>
  );
}
